<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Vukuat Türü</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="Vukuat Türü"/>
            </v-validator>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.IsPlateRequired">Plaka Gerekli</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>